import React from 'react'
import { Link } from 'react-router-dom'

import { Book, File } from 'lucide-react'

import { Card } from '@harvey-frontend/components/ui/card'

export const AppSelection = () => {
  return (
    <div className="flex flex-col gap-2 p-4">
      <h2 className="mb-2 text-sm font-medium">
        Select an action to continue.
      </h2>
      <Card className="transition hover:bg-secondary-hover">
        <Link to="/document-edit" className="flex items-center gap-2 p-2">
          <File className="h-4 w-4" />
          <span className="mt-0.5 text-sm">Edit document</span>
        </Link>
      </Card>

      <div className="flex items-center gap-2">
        <div className="flex-1 border-t" />
        <span className="text-xs text-muted">OR</span>
        <div className="flex-1 border-t" />
      </div>

      <Card className="transition hover:bg-secondary-hover">
        <Link to="/playbook-selection" className="flex items-center gap-2 p-2">
          <Book className="h-4 w-4" />
          <span className="mt-0.5 text-sm">Run playbook</span>
        </Link>
      </Card>
    </div>
  )
}

export default AppSelection
